// css
import "stylesheets/packs/pages/embed.scss";

// JS
// Must Have
import "regenerator-runtime/runtime";
import "jquery";
import "lazysizes";
import Rails from "rails-ujs";
Rails.start();

// Libraries
import ComponentInitializers from "components/shared/ComponentInitializers/ComponentInitializers";
import SocialModal from "shared/components/social_modal";
import PlayCount from "shared/components/play_count";

// Register Window
window.vidio = window.vidio || {};
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.loadMode = 1;
window.Topic = require("shared/topic").default;
window.MobilePlaylist = require("shared/components/mobile_playlist").default; //used for component/player
window.ShowMoreContent = require("shared/show_more_content").default;
window.AhoyPageviewEvent = require("shared/ahoy_pageview_event").default;

// General Components
window.AhoyEvent = require("shared/ahoy_event").default;
window.Kmklabs = require("components/shared/Kmklabs/Kmklabs").default;
window.LivestreamingOverlay = require("embed/components/livestreaming_overlay").default;
window.VideoBlocker = require('components/embed/VideoBlocker/VideoBlocker').default;
window.EmbedShare = require("embed/components/embed_share").default;
window.GtmEmbed = require("embed/components/gtm_embed").default;
window.FontLoader = require("shared/font_loader").default;
window.WebSocketConnection = require("shared/components/live/web_socket_connection").default;
window.EmbedInteractionStatus = require("embed/initializers/embed_interaction_status").default;
window.EmbedFluidPlayerModifier = require("embed/initializers/embed_fluid_player_modifier").default;
window.SocialModal = SocialModal; // For sharing in player
window.Stickerify = require("shared/stickerify").default;
window.EmojiTable = require('desktop/components/emoji_table').default;

// Run component initializers
$(document).ready(function () {
  window.FontLoader.run();
  window.EmbedInteractionStatus.init();
  new ComponentInitializers();

  PlayCount.load();
  window.GtmEmbed.init();
  window.EmbedFluidPlayerModifier.init();
});
